export default __webpack_public_path__ + "static/media/product-image-hover-2.ee4c0fbf.jpg";